<template>
    <div class="main-content">
        <div class="uk-padding">
            <ul class="uk-breadcrumb">
                <li><a href="">Gebruikers</a></li>
            </ul>
            <h1 class="uk-align-left">Gebruikers</h1>
            <div class="uk-align-right">
                <a href="#invite-modal" uk-toggle uk-icon="icon: plus; ratio: 2"></a>
            </div>
            <table class="uk-table">
                <thead>
                    <tr>
                        <th width="30"></th>
                        <th>Naam</th>
                        <th>Email</th>
                        <th>gsm</th>
                        <th width="30">Rol</th>
                        <th width="60"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(u, id) in users">
                        <td><img v-if="u.photoURL" class="round" width="30" :src="u.photoURL"/> <span v-else uk-icon="icon: user; ratio: 1.2"></span></td>
                        <td>{{u.displayName}}</td>
                        <td><a :href="'mailto:' + u.email">{{u.email}}</a></td>
                        <td><a :href="'tel:' + u.phone">{{u.phone}}</a></td>
                        <td v-if="roles && roles[id]">{{userRoles[roles[id].role-1]}}</td>
                        <td>
                            <router-link v-if="roles[id.role < 4] || $store.state.core.user.role >= 4" :to="{ name: 'UserDetail', params: { id: id }}" class="uk-link" uk-icon="icon: cog"></router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="Object.keys(newUsers).length > 0 && newUsers.constructor === Object" class="uk-padding">
            <h4>Gebruikers worden toegevoegd</h4>
            <table class="uk-table">
                <thead>
                    <tr>
                        <th width="30"></th>
                        <th>Naam</th>
                        <th>Email</th>
                        <th>gsm</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(u, id) in newUsers">
                        <td><div uk-spinner></div></td>
                        <td>{{u.firstname + ' ' + u.lastname}}</td>
                        <td><a :href="'mailto:' + u.email">{{u.email}}</a></td>
                        <td><a :href="'tel:' + u.phone">{{u.phone}}</a></td>
                        <td>{{u.error}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div id="invite-modal" uk-modal>
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title">Gebruiker uitnodigen</h2>
                </div>
                <div class="uk-modal-body">
                    <form>
                        <fieldset class="uk-fieldset">
                             <div class="uk-margin">
                                <input class="uk-input" v-model="newInvite.firstname" type="text" placeholder="Voornaam">
                            </div>
                            <div class="uk-margin">
                                <input class="uk-input" v-model="newInvite.lastname" type="text" placeholder="Naam">
                            </div>
                            <div class="uk-margin">
                                <input class="uk-input" v-model="newInvite.email" type="email" placeholder="Email">
                            </div>
                        </fieldset>
                    </form>
                </div>
                <div class="uk-modal-footer">
                    <div class="uk-align-right">
                        <button class="uk-button uk-button-primary uk-align-right uk-modal-close" type="submit" @click.prevent="invite">Uitnodigen</button>
                        <button class="uk-button uk-button-danger uk-align-right uk-modal-close" @click.prevent="cancel">Annuleren</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import {db, rtdb, auth} from '@/CUSTOM/helpers/firebase'
export default {
    name: 'users',
    data () {
        return {
            newInvite: {
                email: null,
                firstname: null,
                lastname: null,
                accepted: true,
            },
            users: {},
            roles: {},
            newUsers: {},
            userRoles: ["Gebruiker", "Moderator", "Beheerder", "Admin"]
        }
    },
    methods: {
        invite () {
            db.collection('newUsers').add(this.newInvite)
            this.cancel()
        },
        cancel () {
            this.newInvite = {
                email: null,
                firstname: null,
                lastname: null,
                phone: null,
                rrid: null
            }
        }
    },
    created () {
        db.collection('users').onSnapshot((snap) => {
            snap.forEach((doc) => {
                Vue.set(this.users, doc.id, doc.data())
            })
        })
        db.collection('users-secure').onSnapshot((snap) => {
            snap.forEach((doc) => {
                Vue.set(this.roles, doc.id, doc.data())
            })
        })
         db.collection('newUsers').onSnapshot((snap) => {
            this.newUsers = {}
            snap.forEach((doc) => {
                Vue.set(this.newUsers, doc.id, doc.data())
            })
        })
    }
}
</script>


// WEBPACK FOOTER //
// Users.vue?33185666